import { DreamBlock } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { DEFAULT_MAX_WIDTH } from '../../constants';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_RICH_TEXT_CONTENT } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import RichTextContentElement from './components/RichTextContentElement';

export const createRichTextContentPlugin = createTElementPluginFactory({
  key: ELEMENT_RICH_TEXT_CONTENT,
  component: withDropTarget(RichTextContentElement as ComponentType<TRenderElementProps>),
  isElement: true,
  isVoid: true,
  options: {
    isDreamBlock: false,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/section_template.png',
      title: 'Rich Text Content',
      subtitle:
        'A section that will be replaced with your Rich Text Content data',
      keywords: ['content', 'text', 'block', 'rich'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: {
        type: ELEMENT_RICH_TEXT_CONTENT,
        width: DEFAULT_MAX_WIDTH,
        children: [
          {
            text: '',
          },
        ],
      } as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['width'],
      validChildrenTypes: [],
    },
  },
});
